'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');

const processInclude = require('base/util');

$(() => {
    processInclude(require('./events.js'));
});
